import { UserUtil } from './../../../../core/user-util';
import { SessionAnuglarService } from './../../../../core/session-anuglar.service';
import { TelaCadastroBasico, CadastrosBasicos } from './../../../../core/tela-cadastro-basico.enum';
import { Utils } from './../../../../core/utils';
import { LoginService } from './../../../../commons/servicos/login.service';
import { LogService } from './../../../../commons/servicos/log.service';
import { Component, OnInit, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { FuncoesClienteService } from '../../../../commons/servicos/funcoes-cliente.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { Message } from 'primeng/primeng';
import { AtendimentoService } from '../../../atendimento/atendimento.service';
import { environment } from './../../../../../environments/environment';
import { Funcoes } from '../../../../commons/model/funcoes';
import { CurrentStatus } from '../../../../core/current-status.enum';
import { ActivatedRoute} from '@angular/router';



@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit, AfterViewInit {

  @Output() abrirModalTela:EventEmitter<boolean> = new EventEmitter<boolean>();

  static path: string[] = [];

  msgs: Message[] = [];
  loading = true;
  funcoes: any[] = [ ];
  username: string;
  exibirTelaUnidade = false;
  exibirAlterarSenha = false;
  unidadeSelecionada = UserUtil.usuarioLogado &&  UserUtil.usuarioLogado.unidPolicial ? UserUtil.usuarioLogado.unidPolicial.descricao: '';
  isSATE = environment.isUnimedBH;
  clienteId = environment.pathImagens;
  ehSeama = this.clienteId == 'seama';
  telaAbrir: CadastrosBasicos =  new CadastrosBasicos();
  isAreaDeTrabalho = true;
  horaAtual: Date;
  nomeCidadao   :string;
  rotaCidadao: string;
  cpfCidadao    :string;
   emailCidadao  :string;

  URL_MAPA_INTERNO : any;
  ehUsuarioAcessoCidadao : boolean;

  private mensagemAlertLimiteAcessos = 'A quantidade de acessos permitidos para essa funcionalidade excedeu.';
  private mensagemAlertSemAcesso = 'Acesso não disponível para essa funcionalidade.';

  constructor(private router: Router,
      private funcoesCliente: FuncoesClienteService,
      private messageService: MessageService,
      private logService: LogService,
      private loginService: LoginService,
      private userUtil: UserUtil,
      private route: ActivatedRoute) {

        // console.log(WelcomeComponent.path);
        WelcomeComponent.path.pop();

        this.userUtil.horaAtual.subscribe(res => {
          this.horaAtual = res;
        })

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
       // console.log(event.url + ' ' + event.id);
      }
      // NavigationEnd
      // NavigationCancel
      // NavigationError
      // RoutesRecognized
    });
  }
  ngAfterViewInit() {
    this.exibirAlterarSenhaUsuarioExpirado();
  }

  ngOnInit() {
    // console.log(UserUtil.usuarioLogado);
    this.ehUsuarioAcessoCidadao = UserUtil.usuarioLogado.usuarioAcessoCidadao;
    SessionAnuglarService.telaDoMedico(false);
    UserUtil.usuarioLogado = JSON.parse(localStorage.getItem('currentUser'));
    this.funcoes = UserUtil.usuarioLogado.funcoes;
    //this.funcoes.push({ cdFuncao: 'VISTORIA', dsFuncao: 'Cadastro de Veículos', link: '/home/welcome/VISTORIA/VISTORIA', idImagem: 'iconeGF.png', title: 'Cadastro de Veículos NOVA'});
    this.loading = false;
    this.username = UserUtil.usuarioLogado.nome;

    this.URL_MAPA_INTERNO = UserUtil.parametrosList['URL_MAPA_INTERNO'] ;
    if(this.route.snapshot.fragment != undefined && this.route.snapshot.fragment != null){
      var dadosCidadao = (this.route.snapshot.fragment).split('#');
      this.rotaCidadao   = dadosCidadao[0];
      this.nomeCidadao   = dadosCidadao[1];
      this.cpfCidadao    = dadosCidadao[2];
      this.emailCidadao  = dadosCidadao[3];
    }


    // console.log(this.route.snapshot.fragment);
    if(this.route.snapshot.fragment != undefined && this.rotaCidadao =='cidadao'){
      this.abrirTela('CAD0048',undefined,'cadastro-cidadao');
    }
    // console.log(UserUtil.usuarioLogado);
  }

  abrirTela(tela, funcao, modulo) {
    // console.log(tela,funcao,modulo);
    const tpFuncao = Funcoes[tela].tpFuncao;
    if (modulo == 'cadastro-cidadao' || modulo == null || modulo.length === 0) {
      this.navegar(tela, modulo, tpFuncao);
      return;
    }
    this.funcoesCliente.consultaControleAcessoFuncionalidade(tela, modulo).subscribe(
      response => {
        const funcoesCliente = response;
        if (funcoesCliente != null  && (funcoesCliente.qtdAcesso > 0 && funcoesCliente.qtdLogados >= funcoesCliente.qtdAcesso)) {
          this.popupShow('', 'Aviso', this.mensagemAlertLimiteAcessos);
        } else if (funcoesCliente != null && (funcoesCliente.qtdAcesso <= 0 || UserUtil.usuarioLogado.cliente.flAtivo === 'N' )) {
          this.popupShow('', 'Aviso', this.mensagemAlertSemAcesso);
        } else {
          this.navegar(tela, modulo, tpFuncao);
        }
      }
    );
  }

  navegar(tela, modulo, tpFuncao) {
    // console.log(tpFuncao);
    WelcomeComponent.path.push(tela);
    this.telaAbrir = Funcoes[tela].telaAbrir;
    const title =  Funcoes[tela].title;
    if (modulo == null || modulo.length === 0) {
      modulo = '5'; // Area de Trabalho
    }
    let nrModulo = Number.parseInt(modulo).valueOf();
    this.loginService.setAction(nrModulo, UserUtil.usuarioLogado.unidPolicial.unidadePolicialPK.cdAgencia,
      UserUtil.usuarioLogado.unidPolicial.unidadePolicialPK.cdUnidPolicial).subscribe(respota => { });
    this.logService.criaRegistroLog(UserUtil.usuarioLogado.login, tela, '9', 2,
    'O usuario: ' + UserUtil.usuarioLogado.nome + ' abriu a tela: ' + tela + ' as: ' + Utils.formataData(UserUtil.sysdate))
              .subscribe(respota => { });

    if (tpFuncao === '2') {
      this.router.navigate(['/home/CADBASICOS/' + this.telaAbrir + '-' + title], { skipLocationChange: true });
    } else if (tpFuncao === '3') {
      this.router.navigate(['/home/CADCTTET/' + 'S' + '-' + 'CADASTRO'], { skipLocationChange: true });
    } else if (tpFuncao === '4') {
      this.router.navigate(['/home/CONCTTET/' + 'S' + '-' + 'CONSULTA'], { skipLocationChange: true });
    } else if (tpFuncao === '5') {
      this.router.navigate(['/home/CAD0086/' + CurrentStatus.AREA_TRABALHO], { skipLocationChange: true });
    } else if (tpFuncao === '6') {
      this.router.navigate(['/home/CADEQP/' + CurrentStatus.EQUIPE], { skipLocationChange: true });
    } else if (tpFuncao === '7') {
      this.router.navigate(['/home/' + Funcoes[tela].link], { skipLocationChange: true });
    } else{
      if(modulo === 'cadastro-cidadao'){
        // console.log("adicinou fragmento : "+this.route.snapshot.fragment);
        this.router.navigate(['/home/' + tela], { skipLocationChange: true,fragment: this.route.snapshot.fragment });
      }else {
        this.router.navigate(['/home/' + tela], { skipLocationChange: true });
      }

    }

    this.abrirModalTela.emit(true);

  }

  popupShow(severidade: string, titulo: string, detalhe: string) {
    this.messageService.add({severity: severidade, summary: titulo, detail: detalhe});
  }

  logSaidaTela(tela: String): void {
    this.logService.criaRegistroLog(UserUtil.usuarioLogado.login, tela, '9', 2,
    'O usuario: ' + UserUtil.usuarioLogado.nome + ' saiu da tela: ' + tela + ' as: ' + Utils.formataData(UserUtil.sysdate));
  }

  trocarUnidade() {
    this.exibirTelaUnidade = true;
  }

  trocarSenha() {
    this.exibirAlterarSenha = true;
  }

  trocarUnidadePersist(unidade) {
    this.loginService.setAction(5, unidade.unidadePolicialPK.cdAgencia,
      unidade.unidadePolicialPK.cdUnidPolicial).subscribe(resposta => {
        UserUtil.usuarioLogado.unidPolicial = unidade;
        localStorage.setItem('currentUser', JSON.stringify(UserUtil.usuarioLogado));
        this.unidadeSelecionada = UserUtil.usuarioLogado.unidPolicial.descricao;
        this.exibirTelaUnidade = false;
       });
  }

  exibirAlterarSenhaUsuarioExpirado() {
      if (UserUtil.usuarioLogado.senhaExpirada) {
        this.exibirAlterarSenha = true;
      } else {
        this.exibirAlterarSenha = false;
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/principal/ui/welcome/welcome.component.ts